import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverable?: boolean;
}

const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  onClick, 
  hoverable = false 
}) => {
  const baseStyles = 'bg-white rounded-xl shadow-md p-kiosk-padding transition-all duration-150 border border-gray-100';
  const interactiveStyles = hoverable ? 'active:shadow-lg cursor-pointer active:scale-[0.98] select-none active:bg-gray-50' : '';
  
  return (
    <div
      className={`${baseStyles} ${interactiveStyles} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card; 